(function() {
  'use strict';

  angular.module('app.stakeholder', []);
})();
